import { Action, createReducer, on } from '@ngrx/store';

import * as MapControlActions from './map-control.actions';

export const mapControlFeatureKey = 'mapControl';

export enum MapDisplayTypeEnum {
  CONTOUR = 'CONTOUR',
  SATELLITE = 'SATELLITE',
}

export interface MapControlState {
  editMode: boolean;
  redflagSelect: boolean;
  drawPolygonMode: boolean;
  drawFreehandMode: boolean;
  displayForest: boolean;
  displayWaterways: boolean;
  displayStands: boolean;
  displayRoads: boolean;
  displayPublicLand: boolean;
  displayKMLUpload: boolean;
  displayContour: MapDisplayTypeEnum;
}

export const initialState: MapControlState = {
  editMode: false,
  redflagSelect: false,
  drawPolygonMode: true,
  drawFreehandMode: false,
  displayForest: true,
  displayWaterways: true,
  displayStands: true,
  displayRoads: true,
  displayPublicLand: false,
  displayKMLUpload: null,
  displayContour: MapDisplayTypeEnum.SATELLITE,
};

const mapControlReducer = createReducer(
  initialState,

  on(MapControlActions.loadMapControls, state => state),
  on(MapControlActions.toggleMapControlsRedflagSelector, state => ({
    ...state,
    redflagSelect: !state.redflagSelect,
    displayPublicLand: true,
    editMode: false,
    drawPolygonMode: false,
    drawFreehandMode: false,
  })),
  on(MapControlActions.setMapControlDrawMode, (state, selector) => ({
    ...state,
    drawPolygonMode: selector.active,
  })),
  on(MapControlActions.toggleMapControlsEditMode, state => ({
    ...state,
    redflagSelect: false,
    editMode: !state.editMode,
    drawPolygonMode: false,
    drawFreehandMode: false,
  })),
  on(MapControlActions.toggleDrawPolygonMode, state => ({
    ...state,
    redflagSelect: false,
    editMode: false,
    drawFreehandMode: false,
    drawPolygonMode: !state.drawPolygonMode,
  })),
  on(MapControlActions.toggleDrawFreehandMode, state => ({
    ...state,
    redflagSelect: false,
    editMode: false,
    drawPolygonMode: false,
    drawFreehandMode: !state.drawFreehandMode
  })),
  on(MapControlActions.toggleMapControlsForest, state => ({
    ...state,
    displayForest: !state.displayForest,
  })),
  on(MapControlActions.toggleMapControlsWaterways, state => ({
    ...state,
    displayWaterways: !state.displayWaterways,
  })),
  on(MapControlActions.toggleMapControlsStands, state => ({
    ...state,
    displayStands: !state.displayStands,
  })),
  on(MapControlActions.toggleMapControlsRoads, state => ({
    ...state,
    displayRoads: !state.displayRoads,
  })),
  on(MapControlActions.toggleMapControlsPublicLand, state => ({
    ...state,
    displayPublicLand: !state.displayPublicLand,
    redflagSelect: state.displayPublicLand ? false : state.redflagSelect,
  })),
  on(MapControlActions.toggleMapControlsKMLUpload, state => ({
    ...state,
    displayKMLUpload: !state.displayKMLUpload,
  })),
  on(MapControlActions.toggleMapControlsBaseMap, state => ({
    ...state,
    displayContour:
      state.displayContour === MapDisplayTypeEnum.SATELLITE ? MapDisplayTypeEnum.CONTOUR : MapDisplayTypeEnum.SATELLITE,
  })),
  on(MapControlActions.resetMapControls, () => ({
    ...initialState,
  })),
  on(MapControlActions.setMapControlsDrawModeOff, state => ({
    ...state,
    drawPolygonMode: false,
    drawFreehandMode: false,
  }))
);

export function reducer(state: MapControlState | undefined, action: Action) {
  return mapControlReducer(state, action);
}
